export const environment = {
  production: false,
  url: 'https://staging.spotpass.com.br/',
  apiBaseUrl: 'https://staging.spotpass.com.br/admin',
  apiReportsUrl: 'https://staging.spotpass.com.br/reports',
  apiFinancialUrl: 'https://staging.spotpass.com.br/financial',
  stockUrl: 'https://staging.spotpass.com.br/stock',
  authBaseUrl: 'https://staging.spotpass.com.br/',
  oAuthClientId: '34a4f46246244f32f13e425d94282c9acecae5317245d1e4eef69cb29be9f707'
};